import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FolderKanban, Receipt, FileText, Settings, LogOut, FileCheck, ArrowDownCircle, Wallet } from 'lucide-react';
import useAuthStore from '../../store/useAuthStore';

const Sidebar = () => {
  const location = useLocation();
  const { logout, user } = useAuthStore();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/dashboard', testId: 'nav-dashboard' },
    { icon: FolderKanban, label: 'Projects', path: '/projects', testId: 'nav-projects' },
    { icon: Receipt, label: 'Expenses', path: '/expenses', testId: 'nav-expenses' },
    { icon: ArrowDownCircle, label: 'Payments', path: '/payments', testId: 'nav-payments' },
    { icon: Wallet, label: 'Contributions', path: '/contributions', testId: 'nav-contributions' },
    { icon: FileCheck, label: 'Invoices', path: '/invoices', testId: 'nav-invoices' },
    { icon: FileText, label: 'Reports', path: '/reports', testId: 'nav-reports' },
    { icon: Settings, label: 'Settings', path: '/settings', testId: 'nav-settings' },
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <div className="w-64 h-screen bg-white border-r border-slate-100 fixed left-0 top-0 flex flex-col">
      <div className="px-6 py-5 border-b border-slate-100">
        <Link to="/dashboard" data-testid="logo-link">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-heading font-bold text-lg">B</span>
            </div>
            <div>
              <h1 className="text-xl font-heading font-bold text-slate-900">Branofy</h1>
              <p className="text-xs text-slate-500 font-medium">Expense Tracker</p>
            </div>
          </div>
        </Link>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={item.testId}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-sm transition-all active:scale-95 ${
                active
                  ? 'bg-orange-50 text-orange-600'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.5} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-100">
        <div className="flex items-center gap-3 px-3 py-2 mb-2">
          <div className="w-9 h-9 bg-gradient-to-br from-orange-400 to-orange-500 rounded-full flex items-center justify-center">
            <span className="text-white font-semibold text-sm">{user?.name?.charAt(0).toUpperCase()}</span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-slate-900 truncate">{user?.name}</p>
            <p className="text-xs text-slate-500 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          className="w-full flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 rounded-lg transition-colors active:scale-95"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.5} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;